import AxiosClient from "../../../services/axios.services";

class ActivoFijoServices {
  getActivoFijo = (params) =>
    AxiosClient.get("/api/app/funcional_equipo_asignado/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getActivoFijoById = (id) =>
    AxiosClient.get(`/api/app/Clima_Encuesta_CheckList/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveActivoFijo = (data) =>
    AxiosClient.post("/api/app/Clima_Encuesta_CheckList/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editActivoFijo = (id, data) =>
    AxiosClient.put(`/api/app/Clima_Encuesta_CheckList/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteActivoFijo = (id) =>
    AxiosClient.delete(`/api/app/Clima_Encuesta_CheckList/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new ActivoFijoServices();
